import {Chip} from "@mui/material";
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';


const ChipPendant = () => {
    return (
        <Chip label='Pendiente' color='warning' variant='filled' size='small' avatar={<DoNotDisturbOnIcon sx={{color: 'white !important'}}/>}/>
    )
}

export default ChipPendant